import apiClient from './client';
import { API_ROUTES } from './routes';

export interface StripeAccount {
  id: string;
  status: 'pending' | 'active' | 'restricted';
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
  createdAt: string;
}

export interface AccountLinkResponse {
  url: string;
}

export interface ExternalAccount {
  id: string;
  object: 'bank_account' | 'card';
  last4: string;
  bankName?: string;
  brand?: string;
  currency: string;
  defaultForCurrency: boolean;
}

export const stripeApi = {
  async getAccount(): Promise<StripeAccount | null> {
    const response = await apiClient.get<StripeAccount | null>(API_ROUTES.CONNECT.ACCOUNTS_ME);
    return response.data;
  },

  async createAccount(): Promise<StripeAccount> {
    const response = await apiClient.post<StripeAccount>(API_ROUTES.CONNECT.ACCOUNTS);
    return response.data;
  },

  async createAccountLink(): Promise<AccountLinkResponse> {
    const response = await apiClient.post<AccountLinkResponse>(API_ROUTES.CONNECT.ACCOUNT_LINKS);
    return response.data;
  },

  async syncAccountStatus(): Promise<StripeAccount> {
    const response = await apiClient.post<StripeAccount>(API_ROUTES.CONNECT.ACCOUNTS_SYNC);
    return response.data;
  },

  async getDashboardLink(): Promise<AccountLinkResponse> {
    const response = await apiClient.post<AccountLinkResponse>(
      API_ROUTES.CONNECT.ACCOUNTS_DASHBOARD,
    );
    return response.data;
  },

  async getExternalAccounts(): Promise<ExternalAccount[]> {
    const response = await apiClient.get<ExternalAccount[]>(API_ROUTES.CONNECT.EXTERNAL_ACCOUNTS);
    return response.data;
  },
};
